import { io } from "socket.io-client";

// Single shared Socket.IO connection for the admin panel. Mirrors the store
// singleton pattern (src/store.js) so any module/component can reuse it.
//
// The JWT is stored raw in localStorage (no "Bearer " prefix — that prefix is
// only added for axios in utils/setAuthToken.js). We pass it in the handshake
// auth payload, which the server verifies with the same JWT secret.

// In dev the CRA server runs on :3000 and does not cleanly proxy the websocket
// upgrade, so connect straight to the API origin. In production the app is
// served same-origin behind nginx, so let socket.io-client infer the origin.
const SOCKET_URL =
  process.env.NODE_ENV === "production" ? undefined : "http://localhost:8000";

let socket = null;

export const connectSocket = () => {
  const token = localStorage.getItem("jwtToken");
  if (!token) return null;
  if (socket && socket.connected) return socket;

  // Drop any stale instance from a previous session before reconnecting.
  if (socket) {
    socket.removeAllListeners();
    socket.disconnect();
    socket = null;
  }

  const options = {
    auth: { token },
    // Deliberately NOT overriding `transports`: the library default
    // (["polling", "websocket"]) starts with plain HTTP long-polling, which
    // works through virtually any reverse proxy, then opportunistically
    // upgrades to a WebSocket. Forcing websocket-first here would skip that
    // fallback and can fail outright if any hop in front of the server
    // (nginx, an ingress, etc.) doesn't cleanly support the WS upgrade.
    reconnection: true,
  };
  socket = SOCKET_URL ? io(SOCKET_URL, options) : io(options);
  return socket;
};

export const getSocket = () => socket;

export const disconnectSocket = () => {
  if (socket) {
    socket.removeAllListeners();
    socket.disconnect();
    socket = null;
  }
};
